import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./index.module.scss";
import Service from "../service";
import { Toast } from "antd-mobile";
import { hideLoading, showLoading } from "@/components/loading";
import ListView from "@/components/AntListView";

const RecycleRecord = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);
  const totalCountRef = useRef(0);

  const getData = async (loading = false, isRefresh = true) => {
    try {
      if (loading) showLoading();

      if (isRefresh) currentPage.current = 1;
      else currentPage.current = currentPage.current + 1;

      const res = await Service.getRecoveryRecord(
        currentPage.current,
        pageSize.current
      );

      if (loading) hideLoading();

      const list = res?.data?.record || [];
      const totalCount = Number(res?.data?.totalCount || 0);
      totalCountRef.current = totalCount;

      setIsLoad(true);

      setRecords((prev) => {
        const next = currentPage.current === 1 ? list : [...prev, ...list];
        const nextLen = next.length;
        const nextHasMore =
          (list?.length || 0) >= pageSize.current &&
          (totalCount ? nextLen < totalCount : true);
        setHasMore(nextHasMore);
        return next;
      });
    } catch (e) {
      hideLoading();
      setIsLoad(true);
      setHasMore(false);
      Toast.show(e?.message || "获取回收记录失败");
    }
  };

  useEffect(() => {
    getData(true, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMore = async () => {
    await getData(false, false);
  };

  const onRefresh = async () => {
    await getData(false, true);
  };

  const RecordItem = (item, idx) => {
    const thumb = item.upgradeImg || "";
    const name = item.remarka || "";
    const count = item.upgradeBeforeNum ?? 0;
    const time = item.recoveryTime || "-";
    const point = item.upgradeResult ?? 0;

    return (
      <div
        className={Styles.recordCard}
        key={item.id || item.afterNftNo || `${time}-${idx}`}
      >
        <div className={Styles.cardTop}>
          <div className={Styles.iconWrap}>
            {thumb ? <img src={thumb} alt="" /> : <span className={Styles.fallbackIcon}>⚡</span>}
          </div>
          <div className={Styles.topText}>
            <div className={Styles.name}>{name}</div>
            <div className={Styles.count}>x{count}</div>
          </div>
        </div>
        <div className={Styles.divideLine} />
        <div className={Styles.infoRow}>
          <span className={Styles.infoLabel}>回收时间：</span>
          <span className={Styles.infoValue}>{time}</span>
        </div>
        <div className={Styles.infoRow}>
          <span className={Styles.infoLabel}>获得积分：</span>
          <span className={Styles.infoValue}>{point}</span>
        </div>
      </div>
    );
  };

  return (
    <div className={Styles.recycleRecordPage}>
      {/* 与 exchangeRecord（领取记录）一致 */}
      <div className={Styles.statusBar} />
      <div className={Styles.navBar}>
        <div
          className={Styles.backButton}
          onClick={() => navigate(-1)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && navigate(-1)}
          aria-label="返回"
        />
        <div className={Styles.title}>回收记录</div>
        <div className={Styles.placeholder} />
      </div>

      <div className={Styles.content}>
        <ListView
          dataSource={records}
          hasMore={hasMore}
          renderItem={RecordItem}
          onRefresh={onRefresh}
          onEndReached={loadMore}
          isLoad={isLoad}
          emtyDesc="暂无回收记录"
        />
      </div>
    </div>
  );
};

export default RecycleRecord;
